module.exports = __webpack_public_path__ + "static/media/bg.e2386996.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.jpeg
// module id = 3699
// module chunks = 0